import { styles } from './Tools.styles';

export const ToolsLoading = () => (
	<>
		<header className={styles.topbar}>
			<div className="h-md w-[96px] animate-pulse rounded bg-grey-25" />
		</header>
		<main className={styles.content}>
			<div className="flex flex-col gap-xs">
				<div className="h-sm w-[128px] animate-pulse rounded bg-grey-25" />
				<div className="h-[28px] w-[192px] animate-pulse rounded bg-grey-25" />
				<div className="h-md w-[288px] animate-pulse rounded bg-grey-25" />
			</div>
			<div className={styles.groupsGrid}>
				{['a', 'b', 'c', 'd'].map((k) => (
					<div key={`tools-group-${k}`} className="h-[160px] animate-pulse rounded-lg bg-grey-25" />
				))}
			</div>
		</main>
	</>
);
